<mat-card class="no-shadow-card">
  <mat-card-header class="card-header-contain-button">
    <mat-card-title class="m-b-0">{{ 'COMPONENT_TITLE.API_KEYS' | translate }}
    </mat-card-title>
    <button mat-button color="primary" (click)="create()">
      <mat-icon>add_box</mat-icon>{{ 'BUTTON.CREATE' | translate }} </button>
  </mat-card-header>

  <mat-card-content>

    <p [innerHTML]="'MESSAGES.API_KEY_DESCRPITION' | translate"></p>

    <div class=" scrollable-x">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChange($event)">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.API_KEY_NAME' | translate }} </th>
          <td mat-cell *matCellDef="let element;">
            <a [routerLink]="['/apikeys', element.apiKey]">{{element.name}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="apiKey">
          <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.API_KEY' | translate }} </th>
          <td mat-cell *matCellDef="let element;">{{element.apiKey}}
            <button mat-icon-button (click)="copyToClipboard(element.apiKey)" [matTooltip]="'TOOLTIP.COPY' | translate"
              style="margin-left:auto; margin-right: 8px; vertical-align: middle; float: right;">
              <mat-icon>content_copy</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="restriction">
          <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.RESTRICTION' | translate }} </th>
          <td mat-cell *matCellDef="let element;">
            {{ ('ITEM.RESTRICTION_ITEM.' + element.restriction) | translate
            }}
            <span *ngIf="element.restrictions">
              <mat-icon inline [matTooltip]="element.restrictions.join(', ')" matTooltipPosition="above"
                aria-label="Restriction Details">more_horiz</mat-icon>
            </span>
            <span *ngIf="!element.restriction">
              -
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.CREATED' | translate }} </th>
          <td mat-cell *matCellDef="let element;"> {{ element.created | date:'yyyy/MM/dd' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> {{ 'ITEM.ACTION' | translate }} </th>
          <td mat-cell *matCellDef="let element">
            <button mat-button color="primary" (click)="displayApikey(element)">
              {{ 'BUTTON.DISPLAY_KEY' | translate }}
            </button>

            <button mat-icon-button color="primary" [routerLink]="['/apikeys', element.apiKey]"
              matTooltip="{{ 'BUTTON.EDIT' | translate }}">
              <mat-icon inline>edit</mat-icon>
            </button>

            <button mat-icon-button color="primary" (click)="delete(element)"
              matTooltip="{{ 'BUTTON.DELETE' | translate }}">
              <mat-icon inline>delete</mat-icon>
            </button>
          </td>
          <td mat-footer-cell *matFooterCellDef hidden></td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
    </div>


  </mat-card-content>

</mat-card>